import React from 'react';
import { formatLiveEventDateTime } from '../../../../../common/utils';
import BlurHashImage from '../../../../BlurHashImage';
import { getLiveVideoLabels } from './liveVideoLabels';
import { useLiveVideo } from './LiveVideoProvider';

// PendingLiveState Component
export default function PendingLiveState({ uiLabels = {} }) {
  const { enabled, liveData, video } = useLiveVideo();
  const liveLabels = getLiveVideoLabels(uiLabels);

  if (!enabled) {
    return null;
  }

  const liveInfo = liveData?.liveInfo;

  const eventDateTime = liveInfo
    ? formatLiveEventDateTime(liveInfo.startDate, liveInfo.timezone)
    : null;

  return (
    <div className="pending-live-container">
      {/* Blur background image */}
      <div className="pending-live-blur-bg">
        <BlurHashImage src={video?.thumb} alt={video?.title} fill priority />
      </div>

      <div className="pending-live-overlay">
        <div className="pending-live-content">
          <h2 className="pending-live-title">
            {liveLabels.STARTING_SOON_TITLE}
          </h2>
          {eventDateTime && (
            <div className="pending-live-details">
              <div className="pending-live-date">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="29"
                  height="29"
                  viewBox="0 0 29 29"
                  fill="none"
                >
                  <path
                    d="M23.668 4.34375H21.043V3.46875C21.043 3.23669 20.9508 3.01413 20.7867 2.85003C20.6226 2.68594 20.4 2.59375 20.168 2.59375C19.9359 2.59375 19.7133 2.68594 19.5492 2.85003C19.3852 3.01413 19.293 3.23669 19.293 3.46875V4.34375H10.543V3.46875C10.543 3.23669 10.4508 3.01413 10.2867 2.85003C10.1226 2.68594 9.90003 2.59375 9.66797 2.59375C9.4359 2.59375 9.21334 2.68594 9.04925 2.85003C8.88516 3.01413 8.79297 3.23669 8.79297 3.46875V4.34375H6.16797C5.70384 4.34375 5.25872 4.52812 4.93053 4.85631C4.60234 5.1845 4.41797 5.62962 4.41797 6.09375V23.5938C4.41797 24.0579 4.60234 24.503 4.93053 24.8312C5.25872 25.1594 5.70384 25.3438 6.16797 25.3438H23.668C24.1321 25.3438 24.5772 25.1594 24.9054 24.8312C25.2336 24.503 25.418 24.0579 25.418 23.5938V6.09375C25.418 5.62962 25.2336 5.1845 24.9054 4.85631C24.5772 4.52812 24.1321 4.34375 23.668 4.34375ZM8.79297 6.09375V6.96875C8.79297 7.20081 8.88516 7.42337 9.04925 7.58747C9.21334 7.75156 9.4359 7.84375 9.66797 7.84375C9.90003 7.84375 10.1226 7.75156 10.2867 7.58747C10.4508 7.42337 10.543 7.20081 10.543 6.96875V6.09375H19.293V6.96875C19.293 7.20081 19.3852 7.42337 19.5492 7.58747C19.7133 7.75156 19.9359 7.84375 20.168 7.84375C20.4 7.84375 20.6226 7.75156 20.7867 7.58747C20.9508 7.42337 21.043 7.20081 21.043 6.96875V6.09375H23.668V9.59375H6.16797V6.09375H8.79297ZM23.668 23.5938H6.16797V11.3438H23.668V23.5938Z"
                    fill="white"
                  />
                </svg>
                <span>{eventDateTime.date}</span>
              </div>
              <div className="pending-live-time">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="29"
                  height="29"
                  viewBox="0 0 29 29"
                  fill="none"
                >
                  <path
                    d="M14.9199 3.4707C12.6702 3.4707 10.4709 4.13784 8.60032 5.38774C6.72971 6.63764 5.27174 8.41417 4.4108 10.4927C3.54985 12.5712 3.32459 14.8583 3.76349 17.0649C4.2024 19.2714 5.28576 21.2982 6.87659 22.889C8.46741 24.4799 10.4942 25.5632 12.7008 26.0021C14.9073 26.441 17.1944 26.2158 19.2729 25.3548C21.3515 24.4939 23.128 23.0359 24.3779 21.1653C25.6278 19.2947 26.2949 17.0955 26.2949 14.8457C26.2917 11.8298 25.0923 8.93842 22.9597 6.80588C20.8272 4.67334 17.9358 3.47389 14.9199 3.4707ZM14.9199 24.4707C13.0163 24.4707 11.1554 23.9062 9.57256 22.8486C7.98974 21.791 6.75608 20.2878 6.02759 18.529C5.29909 16.7703 5.10849 14.835 5.47987 12.968C5.85125 11.1009 6.76794 9.38588 8.11402 8.0398C9.4601 6.69372 11.1751 5.77703 13.0422 5.40564C14.9092 5.03426 16.8445 5.22487 18.6033 5.95336C20.362 6.68186 21.8652 7.91552 22.9228 9.49834C23.9804 11.0812 24.5449 12.9421 24.5449 14.8457C24.542 17.3975 23.527 19.844 21.7226 21.6484C19.9182 23.4528 17.4717 24.4678 14.9199 24.4707ZM21.9199 14.8457C21.9199 15.0778 21.8277 15.3003 21.6636 15.4644C21.4996 15.6285 21.277 15.7207 21.0449 15.7207H14.9199C14.6879 15.7207 14.4653 15.6285 14.3012 15.4644C14.1371 15.3003 14.0449 15.0778 14.0449 14.8457V8.7207C14.0449 8.48864 14.1371 8.26608 14.3012 8.10198C14.4653 7.93789 14.6879 7.8457 14.9199 7.8457C15.152 7.8457 15.3746 7.93789 15.5386 8.10198C15.7027 8.26608 15.7949 8.48864 15.7949 8.7207V13.9707H21.0449C21.277 13.9707 21.4996 14.0629 21.6636 14.227C21.8277 14.3911 21.9199 14.6136 21.9199 14.8457Z"
                    fill="white"
                  />
                </svg>
                <span>{eventDateTime.time}</span>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
